import { get, post } from '@/utils/request';

/**
 * 地块列表接口
 * @param {object} params - 请求参数
 * @returns {Promise}
 */
export function getLandList(params = {}) {
  return get('/api/lt-cus/map_group/v2/land/list', {
    ...params,
  });
}

/**
 * 历史气象数据接口
 * @param {object} params - 请求参数
 * @returns {Promise}
 */
export function getHistoryWeather(params = {}) {
  return get('/api/lt-mobile/temp_rain/list', {

    ...params,
  });
}

/**
 * 核心指标接口
 * @param {object} params - 请求参数
 * @returns {Promise}
 */
export function getMetricsApi(params = {}) {
  return get('/api/lt-cus/agriculture/dashboard/metrics', params);
}

/**
 * 地块构成接口
 * @param {object} params - 请求参数
 * @returns {Promise}
 */
export function getLandComposition(params = {}) {
  return get('/api/lt-cus/agriculture/dashboard/land-composition', params);
}

/**
 * 任务列表接口
 * @param {object} params - 请求参数
 * @returns {Promise}
 */
export function getTaskList(params = {}) {
  return get('/api/lt-cus/agriculture/dashboard/task-list', params);
}

/**
 * 农机状态接口
 * @param {object} params - 请求参数
 * @returns {Promise}
 */
export function getMachineryStatus(params = {}) {
  return get('/api/lt-cus/agriculture/dashboard/machinery-status', params);
}

/**
 * 积温积雨统计接口
 * @param {object} params - 请求参数
 * @returns {Promise}
 */
export function getWeatherMetrics() {
  return get('/api/lt-cus/agriculture/dashboard/weather-metrics');
}
/**
 * 获取长势列表
 * @param {object} params - 请求参数
 * @returns {Promise}
 */
export function getGrowthList() {
  return get('/api/lt-cus/file/list');
}
/**
 * 农事监控-任务汇总

 * @param {object} params - 请求参数
 * @returns {Promise}
 */
export function getTaskSummary(query) {
  return get(`/api/lt-cus/agriculture/dashboard/2/task-summary?cycleName=${query.cycleName}`);
}
/**
 * 农事监控-任务明细

 * @param {object} params - 请求参数
 * @returns {Promise}
 */
export function getTaskDetailApi(query) {
  return get(`/api/lt-cus/agriculture/dashboard/2/task-list?taskType=${query.taskType}&cycleName=${query.cycleName}`);
}
/**
 * 农事监控-任务明细
 * @param {object} params - 请求参数
 * @returns {Promise}
 */
export function getSeederApi() {
  return get(`/api/lt-cus/agriculture/dashboard/2/seeder`);
}
/**
 * 农事监控-任务明细
 * @param {object} params - 请求参数
 * @returns {Promise}
 */
export function getFieldFaultApi(query) {
  return get(`/api/lt-cus/agriculture/dashboard/2/field-fault?cycleName=${query.cycleName}`);
}

export function getDateAndTagidList(params) {
  return get(`/api/ng/gps_device/rtk/dateAndTagidList`,params);

}

// 根据tagid和日期查询rtk轨迹
export function getDataByTagidAndDate(params) {
  return get(`/api/ng/gps_device/rtk/getDataByTagidAndDate`,params);

}


// 根据tagid和日期查询rtk轨迹
export function getgricultureApi(params) {
  return get(`/api/lt-cus/agriculture/dashboard/2/fault/today`,params);
}
// 语音播报
export function voiceBroadcast(params) {
  return get(`/api/lt-cus/ai/auto-reply?`,params);
}

// 获取点位列表
export function getPointList(params) {
  return get(`/api/lt-cus/map_group/v2/point/list`,params);
}
// 土壤墒情
export function getMonitorSummary(params) {
  return get(`/api/lt-cus/agriculture/dashboard/3/getMonitorSummary`,params);
}
// 土壤墒情
export function getPointDetail(id) {
  return get(`/api/lt-mobile/mark_point/device/${id}`);
}
// 土壤墒情
export function getLandWarning() {
  return get(`/api/lt-cus/agriculture/dashboard/3/warning`);
}
// 预警统计
export function getGridCount() {
  return get(`/api/lt-cus/agriculture/dashboard/3/warning/gridCount`);
}
// 网格列表
export function getGridList() {
  return get(`/api/pg/grid/mList?year=2026&pageNum=1&pageSize=99999`);
}
// 预警的小网格
export function getWarningGridList(query) {
  return get(`/api/lt-cus/agriculture/dashboard/3/warning/grid?inspectionType=${query.inspectionType}&cycleName=${query.cycleName}`);
}
// 预警的小网格
export function getGrowthGridList(query) {
  return get(`/api/lt-cus/agriculture/dashboard/2/warning/grid/leaf?inspectionType=${query.inspectionType}`);
}
// 任务执行情况-物资列表
export function getMaterialList(query) {
  return get(`/api/lt-cus/agriculture/dashboard/2/material-list?taskType=${query.taskType}&cycleName=${query.cycleName}`);
}
// 播种期故障统计
export function getMalfunctionData(query) {
  return get(`/api/lt-cus/agriculture/dashboard/4/malfunction/byLand?cycleName=${query.cycleName}`);
}
// 苗期故障统计
export function getSeedlings_emerged(query) {
  return get(`/api/lt-cus/agriculture/dashboard/4/seedlings_emerged?cycleName=${query.cycleName}`);
}
// 出苗统计by地块
export function getSeedlings_emergedByLand(query) {
  return get(`/api/lt-cus/agriculture/dashboard/4/seedlings_emerged/byLand?cycleName=${query.cycleName}`);
}
// 气象与环境实况
export function getWeatherData(query) {
  return get(`/api/lt-cus/agriculture/dashboard/4/weather?cycleName=${query.cycleName}`);
}
// 预警的小网格
export function getEmergenceRateGrid() {
  return get(`/api/lt-cus/agriculture/dashboard/4/emergenceRate/grid`);
}
// 巡田记录卡片
export function getInspectionData(query) {
  return get(`/api/lt-cus/inspection/period/data/all?cycleName=${query.cycleName}&inspectionType=${query.inspectionType}`);
}
// 巡田记录表格
export function getInspectionTableData(query) {
  return get(`/api/lt-cus/inspection/period/data/table?cycleName=${query.cycleName}&inspectionType=${query.inspectionType}`);
}
// 获取网格数据
export function getGridDataBySmallLand(query) {
  return get(`/api/pg/grid/mList?manageLandId=${query.manageLandId}&pageNum=${query.pageNum}&pageSize=${query.pageSize}`);
}
// 获取网格点位
export function getGridPointByManage(query) {
  return get(`/api/lt-cus/grid_point/list?pageNum=${query.pageNum}&pageSize=${query.pageSize}&manageLandId=${query.manageLandId}&pointType=${query.pointType}`);
}
// 调查点的小弹框内容
export function getInvestigatedPointByManage(query) {
  return get(`/api/lt-cus/inspection/getPointsWithTextList?landId=${query.landId}&cycleName=${query.cycleName}&inspectionType=${query.inspectionType}`);
}
// 查询字典内容
export function getDictList(query) {
  return get(`/api/system/dict/data/list?pageNum=${query.pageNum}&pageSize=${query.pageSize}&dictType=${query.dictType}`);
}

/**
 * 积温积雨统计接口
 * @param {object} params - 请求参数
 * @returns {Promise}
 */
export function test() {
  return post('/api/lt-cus/test');
}
export default {
  getLandList,
  getHistoryWeather,
  getMetricsApi,
  getLandComposition,
  getTaskList,
  getMachineryStatus,
  getWeatherMetrics,
  getTaskSummary,
  getSeederApi,
  getDateAndTagidList,
  getDataByTagidAndDate,
  getgricultureApi
};